import React from "react";
import { Link, Redirect } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Form,
  Tooltip,
  OverlayTrigger,
  Row,
  Form as Bform,
} from "react-bootstrap";
import Common, { commonData, getRandomColor } from "./../../Common";
import Header from "./../../Header";
import NewCustomFilter from "../CustomFilter/CustomFilter";
class Releases extends Common {
  constructor(props) {
    super(props);
    var app_token = this.getFromStorage("app_token");
    this.state = {
      redirect: false,
      apiUrl: this.decryptconfigdata("apiUrl"),
      app_token: app_token,
      pod_list: {},
    };
  }
  componentDidMount() {
    this.reportList();
    this.podList();
  }
  reportList() {
    fetch(this.state.apiUrl + "reports/release", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify({
        app_token: this.state.app_token,
        attribute_set_key: "er",
      }),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        console.log(39, findresponse);
        this.setState({
          report_data: findresponse.data,
        });
      });
  }

  podList() {
    fetch(`${process.env.REACT_APP_INTRANET_URL}tattle/podList}`, {
      method: "GET",
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        var podList = findresponse;
        var new_data = {};
        for (var i = 0; i < podList.length; i++) {
          new_data[podList[i].id] = podList[i].value;
        }
        this.setState({
          pod_list: new_data,
        });
      });
  }
  render() {
    console.log(46, this.state.report_data);
    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <Header
          brecum_name={{ name: "", link: "" }}
          brecum_page="Reports"
          pageName="reports"
        />
        <div className="main_custom_class">
          <NewCustomFilter
            //filters={this.state.boarddata.filter}
            isView={true}
            //isAdmin={this.state.boarddata.is_admin == 1 ? 1:0}
            enebleClickFilter={() => this.createFilter(0)}
            enebleAdvancedClickFilter={() => this.createFilter(1)}
          />
          <Container fluid className="g-0 fullHeight">
            <div className="page-content pt-1 new-content-main">
              <div className="parentcrdclass card-body">
                <div className="justify-content-end align-items-center gx-2 row">
                  <div class="col">
                    <div
                      class="board-parent__division"
                      style={{ marginTop: "8px" }}
                    >
                      <a class="txt-dark underline-none" href="/board/list">
                        <span class="new_back">
                          <svg
                            width="14"
                            height="12"
                            viewBox="0 0 14 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.0026 5.33333H3.27856L6.80723 1.80467L5.86456 0.862L0.726562 6L5.86456 11.138L6.80723 10.1953L3.27856 6.66667H13.0026V5.33333Z"
                              fill="#5C5F62"
                            ></path>
                          </svg>
                        </span>
                        &nbsp;
                      </a>
                      <span class="inline-edit-board"> Releases </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="report-list table-wrap">
                    <table>
                      <thead>
                        <th width="410">Release</th>
                        <th width="410">Planned</th>
                        <th width="410">Released</th>
                        <th width="410">Completed</th>
                        <th width="410">Not Started</th>
                        <th width="410">Spill Over</th>
                        <th width="410">Ad Hoc</th>
                        <th width="410">Total Effort(Hours)</th>
                        <th width="410">Velocity</th>
                        <th width="410">Avg Velocity</th>
                        <th width="410">Completion</th>
                      </thead>
                      <tbody>
                        {/*this.state.report_data !== undefined && this.state.report_data.length > 0  ?
                                         this.state.report_data.map((item, index) => (
                                            <tr>
                                                <td>{this.state.pod_list && this.state.pod_list[item.pod_id]}</td>
                                                <td>{item.type_customer}</td>
                                                <td>{item.type_internal}</td>
                                                <td>{item.category_feature}</td>
                                                <td>{item.category_bug}</td>
                                                <td>{item.category_tech}</td>
                                                <td>{item.total}</td>
                                                <td>{item.total_hrs}</td>
                                            </tr>
                                         )) : ""*/}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
export default Releases;
